module.exports = __webpack_public_path__ + "media/sfx_enter_4.6271ac42.wav";